import { ELocalStorageKeys } from "../store";

const localStorageKeysMap = {
  [ELocalStorageKeys.MM__AUTH_SDK__LEGAL_ACTIVE_ID]: 'auth_sdk_legal_active_id',
  [ELocalStorageKeys.MM__AUTH_SDK__LEGAL_ACCESS_TOKEN]: 'auth_sdk_legal_access_token',
  [ELocalStorageKeys.MM__AUTH_SDK__LEGAL_REFRESH_TOKEN]: 'auth_sdk_legal_token',
  [ELocalStorageKeys.MM__AUTH_SDK__LEGAL_TOKEN_EXPIRE]: 'auth_sdk_legal_token_exp_time',
  [ELocalStorageKeys.MM__AUTH_SDK__ACCESS_TOKEN]: 'auth_sdk_access_token',
  [ELocalStorageKeys.MM__AUTH_SDK__REFRESH_TOKEN]: 'auth_sdk_token',
  [ELocalStorageKeys.MM__AUTH_SDK__TOKEN_EXPIRE]: 'auth_sdk_token_exp_time',
  [ELocalStorageKeys.MM__AUTH_SDK__MAGNIT_ID_CODE]: 'auth_sdk_magnit_id_code',
}


export function useB2BCookieController() {
  for (const key of Object.values(localStorageKeysMap)) {
    localStorage.removeItem(key || '');
  }
}